import React from 'react';
import type {RadioGroupState} from '@react-stately/radio';

interface RadioGroupContext {
    isEmphasized?: boolean;
    name?: string;
    validationState?: 'valid' | 'invalid';
    state: RadioGroupState;
}

export const RadioContext = React.createContext<RadioGroupContext | null>(null);

export function useRadioProvider(): RadioGroupContext {
    return React.useContext(RadioContext) as RadioGroupContext;
}
